module.exports = __webpack_public_path__ + "img/pacmanmodel (12).a5df7dd8.jpg";